import { useEffect } from 'react'

import { Dropdown } from 'react-bootstrap'

import { Pericope } from '../../resources/ExegeticalResources'

const stepNumber = (id = '') => {
    const match = id.match(/\d+$/)
    return match ? match[0] : ''
}

const dropdownItems = (pericopesMap: Map<string, Pericope[]>) => {
    const items: { id?: string; title: string; verseRange: string }[] = []
    pericopesMap.forEach((pericopes) => {
        pericopes.forEach(({ verseRange, steps }) => {
            items.push({ title: verseRange, verseRange })
            steps.forEach(({ id, title, number }) => {
                // LEGACY: SRV used to not provide steps numbers
                const numberLabel = number ?? stepNumber(id)
                items.push({ id, title: numberLabel ? `${numberLabel}. ${title}` : title, verseRange })
            })
        })
    })
    return items
}

interface ExegeticalResourceSelectorProps {
    pericopesMap: Map<string, Pericope[]>
    stepId: string
    setStepId: (id: string) => void
    idSuffix: string
}

export const ExegeticalResourceSelector = ({
    pericopesMap,
    stepId,
    setStepId,
    idSuffix
}: ExegeticalResourceSelectorProps) => {
    const items = dropdownItems(pericopesMap)
    const selectedItem = items.find((item) => stepId === item.id)

    // show first pericope if it exists
    useEffect(() => {
        if (!selectedItem && items.length > 1 && items[1].id) {
            setStepId(items[1].id)
        }
    }, [items, selectedItem, setStepId])

    return (
        <Dropdown id={`resources-dropdown-${idSuffix}`} className="resources-select" align="end">
            <Dropdown.Toggle className="sl-dropdown styled-dropdown-select">
                {selectedItem?.title ?? ''}
            </Dropdown.Toggle>
            <Dropdown.Menu className="scrollable-dropdown styled-dropdown-select-menu">
                {items.map(({ id, title }) =>
                    id ? (
                        <Dropdown.Item onClick={() => setStepId(id)} active={id === stepId} key={id}>
                            <div className="resources-dropdown-item">
                                <div className="resources-dropdown-header">
                                    <span className="resources-dropdown-title">{title}</span>
                                </div>
                            </div>
                        </Dropdown.Item>
                    ) : (
                        <Dropdown.Header key={title}>{title}</Dropdown.Header>
                    )
                )}
            </Dropdown.Menu>
        </Dropdown>
    )
}
